import React from 'react';
import { cn } from '@/lib/utils';

interface WaveformDividerProps {
  className?: string;
  animated?: boolean;
}

export const WaveformDivider: React.FC<WaveformDividerProps> = ({
  className,
  animated = false
}) => {
  return (
    <div className={cn('w-full py-8', className)}>
      <svg
        width="100%"
        height="40"
        viewBox="0 0 800 40"
        className={cn(
          'opacity-60',
          animated && 'animate-pulse'
        )}
      >
        <path
          d="M0 20L50 10L100 30L150 15L200 25L250 12L300 28L350 18L400 22L450 14L500 26L550 16L600 24L650 19L700 27L750 13L800 21"
          stroke="url(#waveform-gradient)"
          strokeWidth="2"
          fill="none"
          className="drop-shadow-[0_0_4px_hsl(var(--cyber-green))]"
        />
        <defs>
          <linearGradient id="waveform-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(var(--cyber-green))" />
            <stop offset="50%" stopColor="hsl(var(--cyber-yellow))" />
            <stop offset="100%" stopColor="hsl(var(--cyber-blue))" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};